/**
 * Reine Fortschritts-Logik der Vorgang-Statuszelle (DOM-frei, unit-testbar).
 *
 * SP14 (Mobile-/Konsistenz-Pass, Review-Screenshot 15.38.59 „Sinnfreie 0/0-
 * Anzeige"): Ein Vorgang OHNE To-dos hat keinen sinnvollen Fortschritt — statt
 * „0/0 erledigt" wird die Anzeige unterdrückt (User-Entscheidung F1/F2: ohne
 * To-dos ist der Vorgang direkt erledigbar, es gibt kein offen/in Arbeit).
 */

/** Fortschrittsanteil 0..1 (0, wenn keine To-dos vorhanden sind). */
export function progressValue(erledigt?: number | null, gesamt?: number | null): number {
    const total = gesamt ?? 0;
    const done = erledigt ?? 0;
    if (total <= 0) return 0;
    return Math.min(1, Math.max(0, done / total));
}

/**
 * Label „N/M erledigt" — oder `null`, wenn es keine To-dos gibt (dann keine
 * „0/0"-Anzeige). Negative/undefinierte Werte werden auf 0 normalisiert.
 */
export function progressLabel(erledigt?: number | null, gesamt?: number | null): string | null {
    const total = gesamt ?? 0;
    if (total <= 0) return null;
    const done = Math.max(0, erledigt ?? 0);
    return `${done}/${total} erledigt`;
}
